// import React, {useEffect, useState} from "react";
// import {Navbar, Nav, Container} from "react-bootstrap";
// import {HiOutlineMenu} from "react-icons/hi";
// import {MdClose} from "react-icons/md";
// import {HeaderStyled} from "./header.styled";
// import {Link} from "react-scroll";
// import homeIm from "../../assets/b.png";
// const navlinks = [
//   "Home",
//   "About",
//   "Services",
//   "Portfolio",
//   "Pricing",
//   "Team",
//   "Contact",
// ];
// const Header = () => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [navBarScrolled, setNavBarScrolled] = useState(false);
//   const handleResize = () => {
//     if (window.innerWidth >= 992) {
//       setIsOpen(false);
//     }
//   };
//   const changeBackground = () => {
//     if (window.scrollY >= 50) {
//       setNavBarScrolled(true);
//     } else {
//       setNavBarScrolled(false);
//     }
//   };
//   useEffect(() => {
//     window.addEventListener("resize", handleResize);
//     //Removing the event listener will make the component more robust, make the app quicker, and reduce memory leaks.
//     // -If the computations were more expensive, that'd be wasted CPU time on a component that doesn't exist in the DOM; better to remove the need for the calculations entirely
//     // -If the added listener happens to fire extremely rapidly (like scroll), removing the listener could help performance, especially if there are multiple components like these
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   useEffect(() => {
//     window.addEventListener("scroll", changeBackground);
//     return () => {
//       window.removeEventListener("scroll", changeBackground);
//     };
//   });
//   return (
//     <HeaderStyled className={navBarScrolled ? "active" : ""}>
//       <Navbar>
//         <Container>
//         <Navbar.Brand>
//         <img
//           src={homeIm}
//           width="80"
//           height="70"
//         />
//       </Navbar.Brand>
//           <Nav className={`ms-auto${isOpen ? " nav-links-container" : ""}`}>
//             <MdClose
//               className="d-block d-lg-none close-icon"
//               color="green"
//               onClick={() => setIsOpen(!isOpen)}
//             />
//             {navlinks.map((link, idx) => (
//               <Link
//                 key={idx}
//                 to={`${link.toLowerCase()}`}
//                 smooth
//                 offset={-40}
//                 duration={250}
//                 spy
//                 activeClass="active"
//                 onClick={() => window.innerWidth <= 992 && setIsOpen(!isOpen)}
//               >
//                 {link}
//               </Link>
//             ))}
//           </Nav>
//           <Nav className="ms-auto d-flex d-lg-none">
//             <HiOutlineMenu
//               className="menu-icon"
//               onClick={() => setIsOpen(!isOpen)}
//             />
//           </Nav>
//         </Container>
//       </Navbar>
//     </HeaderStyled>
//   );
// };
// export default Header;

// import React, { useEffect, useState } from "react";
// import { Navbar, Nav, Container } from "react-bootstrap";
// import { HiOutlineMenu } from "react-icons/hi";
// import { MdClose } from "react-icons/md";
// import { HeaderStyled } from "./header.styled";
// import { Link } from "react-scroll";
// import homeImLight from "../../assets/b.png"; // Change the paths accordingly
// import homeImDark from "../../assets/bb.png"; // Change the paths accordingly

// const navlinks = ["Home", "About", "Services", "Portfolio", "Pricing", "Team", "Contact"];

// const Header = () => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [navBarScrolled, setNavBarScrolled] = useState(false);
//   const [theme, setTheme] = useState("light"); // Added theme state

//   const handleResize = () => {
//     if (window.innerWidth >= 992) {
//       setIsOpen(false);
//     }
//   };

//   const changeBackground = () => {
//     if (window.scrollY >= 50) {
//       setNavBarScrolled(true);
//     } else {
//       setNavBarScrolled(false);
//     }
//   };

//   useEffect(() => {
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   useEffect(() => {
//     window.addEventListener("scroll", changeBackground);
//     return () => {
//       window.removeEventListener("scroll", changeBackground);
//     };
//   });

//   const toggleTheme = () => {
//     setTheme((prevTheme) => (prevTheme === "light" ? "dark" : "light"));
//   };

//   return (
//     <HeaderStyled className={navBarScrolled ? "active" : ""}>
//       <Navbar>
//         <Container>
//           <Navbar.Brand>
//             <img
//               src={theme === "light" ? homeImLight : homeImDark}
//               width="80"
//               height="70"
//             />
//           </Navbar.Brand>
//           <Nav className={`ms-auto${isOpen ? " nav-links-container" : ""}`}>
//             <MdClose
//               className="d-block d-lg-none close-icon"
//               color="green"
//               onClick={() => setIsOpen(!isOpen)}
//             />
//             {navlinks.map((link, idx) => (
//               <Link
//                 key={idx}
//                 to={`${link.toLowerCase()}`}
//                 smooth
//                 offset={-40}
//                 duration={250}
//                 spy
//                 activeClass="active"
//                 onClick={() => window.innerWidth <= 992 && setIsOpen(!isOpen)}
//               >
//                 {link}
//               </Link>
//             ))}
//           </Nav>
//           <Nav className="ms-auto d-flex d-lg-none">
//             <HiOutlineMenu
//               className="menu-icon"
//               onClick={() => setIsOpen(!isOpen)}
//             />
//           </Nav>
//           <button onClick={toggleTheme}>Toggle Theme</button>
//         </Container>
//       </Navbar>
//     </HeaderStyled>
//   );
// };

// export default Header;

import React, { useEffect, useState, useContext } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { HiOutlineMenu } from "react-icons/hi";
import { MdClose } from "react-icons/md";
import { HeaderStyled } from "./header.styled";
import { Link } from "react-scroll";
import homeImLight from "../../assets/b.png";
import homeImDark from "../../assets/bb.png";
import ThemeContext from "../../contexts/ThemeContext"; // Assuming you have a ThemeContext defined

const navlinks = ["Home", "About", "Services", "Portfolio", "Pricing", "Team", "Contact"];

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [navBarScrolled, setNavBarScrolled] = useState(false);
  const { theme } = useContext(ThemeContext); // Assuming you have a theme state in ThemeContext

  const handleResize = () => {
    if (window.innerWidth >= 992) {
      setIsOpen(false);
    }
  };

  const changeBackground = () => {
    if (window.scrollY >= 50) {
      setNavBarScrolled(true);
    } else {
      setNavBarScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", changeBackground);
    return () => {
      window.removeEventListener("scroll", changeBackground);
    };
  });

  return (
    <HeaderStyled className={navBarScrolled ? "active" : ""}>
      <Navbar>
        <Container>
          <Navbar.Brand>
            <img
              src={theme === "light" ? homeImLight : homeImDark}
              width="80"
              height="70"
              alt="Logo"
            />
          </Navbar.Brand>
          <Nav className={`ms-auto${isOpen ? " nav-links-container" : ""}`}>
            <MdClose
              className="d-block d-lg-none close-icon"
              color="green"
              onClick={() => setIsOpen(!isOpen)}
            />
            {navlinks.map((link, idx) => (
              <Link
                key={idx}
                to={`${link.toLowerCase()}`}
                smooth
                offset={-40}
                duration={250}
                spy
                activeClass="active"
                onClick={() => window.innerWidth <= 992 && setIsOpen(!isOpen)}
              >
                {link}
              </Link>
            ))}
          </Nav>
          <Nav className="ms-auto d-flex d-lg-none">
            <HiOutlineMenu
              className="menu-icon"
              onClick={() => setIsOpen(!isOpen)}
            />
          </Nav>
        </Container>
      </Navbar>
    </HeaderStyled>
  );
};

export default Header;
